import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import {
  legalEntityKeys,
  legalEntityRepository,
} from '@webapp/platform/legal-entities/data-access/repositories/LegalEntityRepository'
import { type UpdateLegalEntityInput } from '@webapp/platform/legal-entities/data-access/types/UpdateLegalEntityInput'
import { LegalEntity } from '@webapp/platform/legal-entities/entities/LegalEntity'

interface UpdateLegalEntityParams {
  uuid: string
  input: UpdateLegalEntityInput
}

export const useMutateUpdateLegalEntity = () => {
  const queryClient = useQueryClient()

  const { mutateAsync, isLoading, isSuccess, isError, error } = useMutation<
    LegalEntity,
    RepoError,
    UpdateLegalEntityParams
  >({
    mutationFn: async ({ uuid, input }: UpdateLegalEntityParams) => {
      const constructor = await legalEntityRepository.update(uuid, input)

      return new LegalEntity(constructor)
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: legalEntityKeys.list })
    },
  })

  return { mutateAsync, isLoading, isSuccess, isError, error }
}
